<template>
  <Toast />
  <ConfirmDialog group="headless">
    <template #container="{ message, acceptCallback, rejectCallback }">
      <div class="flex flex-col items-center p-8 bg-surface-0 dark:bg-surface-900 rounded">
        <div
          class="rounded-full bg-white outline outline-black inline-flex justify-center items-center h-24 w-24 -mt-20">
          <i class="pi pi-question text-5xl"></i>
        </div>
        <span class="font-bold text-2xl block mb-2 mt-6">{{ message.header }}</span>
        <p class="mb-0">{{ message.message }}</p>
        <div class="flex items-center gap-2 mt-6">
          <Button :label="message.rejectLabel" outlined @click="rejectCallback" class="w-32"></Button>
          <Button :label="message.acceptLabel" @click="acceptCallback" class="w-32"></Button>
        </div>
      </div>
    </template>
  </ConfirmDialog>
  <ModalSalesReturnDetail v-if="modalShowSalesReturnDetail" @closeModal="closeModal"
    :salesReturnDetail="selectedSalesReturnDetail" :parentItemId="$route.params?.id" />
  <ModalChooseReturnProduct v-if="modalShowChooseReturnProduct" @closeModal="closeModalProduct" :salesReturn="salesReturn" @submit="submitProduct" :productSalesReturn="productSalesReturn" />
  <ModalSalesOrder v-if="modalShowSalesOrder" @closeModal="closeModalOrder" @submit="postSalesReturn" :params="{ limit: 10, page: 1, status: 'paid' }" />
  <IndexView />
  <div id="overlay" class="fixed inset-0 bg-black bg-opacity-30 z-30" :class="{ hidden: !isBlur }"></div>
  <ViewContainer>
    <section class="p-6">
      <BackButton class="mb-5" to_url="/sales-return" />
      <PageTitle title="Edit Retur Penjualan" />
      <div
        class="bg-white dark:bg-dark-900 w-full rounded-lg py-6 px-5 shadow-lg shadow-light-100 dark:shadow-dark-500 dark:text-dark-500">
        <div id="table-header" class="mb-5 mt-5 flex justify-between">
          <AddButton v-if="salesReturn.status != 'paid'" to_url="#" button_text="Pilih Item"
            button_class="text-base py-2 font-medium" @click="notifyChooseOrder" />
          <AddButton v-if="salesReturn.status != 'paid'" to_url="#" button_text="Pilih Order"
            button_class="text-base py-2 font-medium" @click="showModalOrder" />
        </div>
        <InputTextCustom v-model="salesReturn.sales_order.code" label="Sales Order" id="pilih-so"
          placeholder="Sales Order" :valid="validation.sales_order_id.valid"
          :error-message="validation.sales_order_id.message" :disable_input="true" />
        <InputTextAreaCustom v-model="salesReturn.note" id="marketing-address" label="Catatan"
          placeholder="Catatan" input_class="w-full" :valid="validation.note.valid"
          :error-message="validation.note.message" />

        <div class="overflow-x-auto mt-5">
          <div class="inline-block min-w-full align-middle">
            <div class="overflow-hidden shadow-lg rounded-lg">
              <TableComponent>
                <TableHead>
                  <TableRow>
                    <TableHeadCell>No</TableHeadCell>
                    <TableHeadCell>Action</TableHeadCell>
                    <TableHeadCell>Status</TableHeadCell>
                    <TableHeadCell>Kode Item</TableHeadCell>
                    <TableHeadCell>Nama Item</TableHeadCell>
                    <TableHeadCell numeric>Jumlah dipesan</TableHeadCell>
                    <TableHeadCell numeric>Sudah diretur</TableHeadCell>
                    <TableHeadCell numeric>Jumlah</TableHeadCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow v-if="salesReturnDetails?.length == 0">
                    <TableCell colspan="8" customClass="text-center italic text-gray-400 dark:text-dark-500"
                      noTextColor>
                      Belum ada data
                    </TableCell>
                  </TableRow>
                  <TableRow v-else v-for="(salesReturnDetail, index) in salesReturnDetails"
                    :key="salesReturnDetail.id" :index="index" isBody>
                    <TableCell>{{ index + 1 }}</TableCell>
                    <TableCell>
                      <div class="justify-center items-center text-gray-500 dark:text-gray-400 flex" v-if="salesReturn.status != 'paid'">
                        <button v-if="salesReturnDetail.isEdit" :id="'edit-data-' + salesReturnDetail.id"
                          @click="submitSalesReturnDetail(salesReturnDetail)"
                          class="border border-gray-400 hover:border-green-700 hover:bg-green-400 flex justify-center items-center mx-1 p-2 rounded-md group">
                          <ArrowDownTrayIcon class="h-4 w-4 group-hover:text-green-700" />
                        </button>
                        <button :id="'delete-data-' + salesReturnDetail.id"
                          @click="deleteSalesReturnDetail(salesReturnDetail)"
                          class="border border-gray-400 hover:border-red-500 hover:bg-red-400 flex justify-center items-center mx-1 p-2 rounded-md group">
                          <TrashIcon class="h-4 w-4 group-hover:text-red-700" />
                        </button>
                      </div>
                    </TableCell>
                    <TableCell>
                      <span :class="{
                        'bg-red-500 dark:bg-red-500 text-light-50 dark:text-white': salesReturnDetail.isEdit,
                        'bg-green-500 dark:bg-green-500 text-white dark:text-white': !salesReturnDetail.isEdit
                      }" class="px-2 py-1 rounded-full text-sm font-medium">
                        {{ salesReturnDetail.isEdit ? 'Belum Disimpan' : 'Tersimpan' }}
                      </span>
                    </TableCell>
                    <TableCell>{{ salesReturnDetail.items?.code }}</TableCell>
                    <TableCell>{{ salesReturnDetail.items?.name }}</TableCell>
                    <TableCell numeric>
                      {{ salesReturnDetail.qty_order }}
                    </TableCell>
                    <TableCell numeric>
                      {{ salesReturnDetail.returnedQty }}
                    </TableCell>
                    <TableCell>
                      <div v-if="salesReturn.status != 'paid'" class="flex items-center rounded-lg p-1">
                        <button @click="reduceItem(salesReturnDetail)" class="p-1 text-gray-500 hover:text-blue-500 transition-colors">
                          <MinusCircleIcon class="h-5 w-5" />
                        </button>
                        <InputTextCustom v-model="salesReturnDetail.qty" id="item-min-qty-per-unit" type="number" div_class="w-20" min="1" @input="inputQty(salesReturnDetail)"/>
                        <button @click="addItem(salesReturnDetail)" class="p-1 text-gray-500 hover:text-blue-500 transition-colors">
                        <PlusCircleIcon class="h-5 w-5" />
                        </button>
                      </div>
                      <div v-else>
                        {{ salesReturnDetail.qty }}
                      </div>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </TableComponent>
            </div>
          </div>
        </div>

        <div class="flex justify-center" v-if="salesReturn.status != 'paid'">
          <SubmitButton id="submit" @click="notifyChooseOrder" button_name="Simpan"
            button_class="mt-3 mx-2 rounded-md bg-color-1 px-6 py-2 text-base font-semibold text-color-4 shadow-sm hover:bg-color-2 hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-color-3 block" />
          <SubmitButton id="submit" @click="notifyChooseOrder" button_name="Posting"
            button_class="mt-3 mx-2 rounded-md bg-color-1 px-6 py-2 text-base font-semibold text-color-4 shadow-sm hover:bg-color-2 hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-color-3 block" />
        </div>
        <div class="flex justify-center" v-if="salesReturn.status == 'paid'">
          Sudah Diposting
        </div>
      </div>
    </section>
  </ViewContainer>
</template>

<script>
import IndexView from '@/views/IndexView.vue';
import PageTitle from '@/components/PageTitle.vue';
import BackButton from '@/components/buttons/BackButton.vue';
import InputTextAreaCustom from '@/components/form/InputTextAreaCustom.vue';
// import TextArea from '@/components/form/TextArea.vue';
import SubmitButton from '@/components/form/SubmitButton.vue';
import { mapActions, mapGetters } from 'vuex';
import { Button, ConfirmDialog, Toast } from "primevue";
import AddButton from "@/components/buttons/AddButton.vue";
import {
  TableComponent,
  TableHead,
  TableRow,
  TableHeadCell,
  TableBody,
  TableCell,
} from "@/components/table";
import ModalSalesReturnDetail from '@/components/modals/ModalSalesReturnDetail.vue';
import { TrashIcon, ArrowDownTrayIcon, PlusCircleIcon, MinusCircleIcon } from "@heroicons/vue/24/solid";
import ModalChooseReturnProduct from '@/components/modals/ModalChooseReturnProduct.vue';
import ViewContainer from "@/components/ViewContainer.vue";
import InputTextCustom from '@/components/form/InputTextCustom.vue';
import ModalSalesOrder from '@/components/modals/ModalSalesOrder.vue';

export default {
  name: "AddEditCustomer",
  props: ['id'],
  components: {
    IndexView, InputTextAreaCustom, PageTitle, BackButton, SubmitButton, Button, ConfirmDialog, Toast,
    AddButton, TableComponent, TableHead, TableRow, TableHeadCell, TableBody, TableCell,
    ModalSalesReturnDetail, TrashIcon, ModalChooseReturnProduct, ViewContainer, PlusCircleIcon, MinusCircleIcon, ArrowDownTrayIcon, InputTextCustom, ModalSalesOrder
  },
  data() {
    return {
      salesReturn: {
        form_type: null,
        sales_order_id: null,
        note: "",
        sales_order: {
          code: null,
          id: null,
        },
      },
      salesReturnsPaid: [],
      salesReturnDetails: [],
      isEdit: false,
      validation: {
        form_type: {
          valid: true,
          message: ''
        },
        sales_order_id: {
          valid: true,
          message: ''
        },
        note: {
          valid: true,
          message: ''
        },
      },
      validationSalesReturnDetail: {
        item_id: {
          valid: true,
          message: ''
        },
        qty: {
          valid: true,
          message: ''
        },
      },
      modalShowSalesReturnDetail: false,
      isBlur: false,
      selectedSalesReturnDetail: null,
      modalShowChooseReturnProduct: false,
      modalShowSalesOrder: false,
    }
  },
  async created() {
    await this.fetchSalesOrders({ limit: 100, status: 'paid' });
  },
  computed: {
    ...mapGetters("sales_orders", ["allSalesOrders"]),
  },
  methods: {
    ...mapActions("sales_orders", ["fetchSalesOrders"]),
    ...mapActions('sales_returns', ['createSalesReturn']),
    async postSalesReturn(order) {
      try {
        const salesReturnData = {
          form_type: this.formType,
          sales_order_id: order.id,
          status: "pending",
        };

        const { data } = await this.createSalesReturn(salesReturnData);

        await this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Retur Penjualan berhasil dibuat', life: 5000 });
        this.$router.push(`/sales-return/edit/${data.id}`);
      }
      catch (error) {
        console.error('Failed to save inbound items form:', error);

        if (error.status === 400 && error.response.data.errors) {
          this.validationErrors(error.response.data.errors);
          this.$toast.add({ severity: 'error', summary: 'Failed', detail: error.response.data.message, life: 5000 });
        }
        else {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: error.response.data.message, life: 5000 });
        }
      }
    },
    validationErrors(errorMessage) {
      for (let index = 0; index < this.field.length; index++) {
        this.validation[this.field[index]].valid = true;
        this.validation[this.field[index]].message = '';
      }

      errorMessage.forEach((error) => {
        if (this.validation[error.field]) {
          this.validation[error.field].valid = false;
          this.validation[error.field].message = error.message;
        }
      });
    },
    showModalOrder() {
      this.modalShowSalesOrder = true;
      this.isBlur = true;
    },
    closeModalOrder() {
      this.isBlur = false;
      this.modalShowSalesOrder = false;
    },
    notifyChooseOrder() {
      this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'Kamu belum memilih order', life: 3000 });
    },
  },
}
</script>